import React from 'react';
import { connect } from 'react-redux';
import CarrierRow from './CarrierRow';

class CarrierList extends React.PureComponent {
  render() {
    const { organizationsList, organizationFilter, organizationActivePage } = this.props;

    const filteredOrgList = organizationsList.filter((org) => (
      organizationFilter
      && (!org.organization_name.toLowerCase().includes(organizationFilter.toLowerCase()))
        ? null : org
    ));

    const filteredAndPagedArray = [];
    for (let i = 0; i < filteredOrgList.length; i += 25) {
      filteredAndPagedArray.push(filteredOrgList.slice(i, i + 25));
    }

    return (
      <tbody>
        {
          filteredAndPagedArray[organizationActivePage - 1]
            ? (
              filteredAndPagedArray[organizationActivePage - 1].map((org) => (
                <CarrierRow organization={org} />
              ))
            ) : null
        }
      </tbody>
    );
  }
}

const mapStateToProps = (store) => ({
  organizationsList: store.logos.organizationsList,
  organizationFilter: store.logos.organizationFilter,
  organizationActivePage: store.logos.organizationActivePage,
});

export default connect(mapStateToProps)(CarrierList);
